var $ = jQuery;

class Avatar {
    constructor(frames) {
        this.frames = frames;
        this.talk = frames[0];
        this.currentFrame = 0;
        this.element = "";
    }

    changeAvatar() {
        this.currentFrame += 1;
        if (this.currentFrame >= this.frames.length) {
            this.currentFrame = 0;
        }
        this.element.attr("src", this.frames[this.currentFrame]);
    }

    getCurrentImage() {
        return this.frames[this.currentFrame];
    }

    getFrameIndexFromSrc(src) {
        var index = 0;
        this.frames.forEach(function (frame, i) {
            if (src == frame) {
                index = i;
            }
        });
        return index;
    }
}

class Guide {
    constructor() {
        this.leftAvatar = new Avatar(guideData.leftAvatar);
        this.rightAvatar = new Avatar(guideData.rightAvatar);
        this.leftAvatar.element = $("#guideLeftAvatar img");
        this.rightAvatar.element = $("#guideRightAvatar img");

        this.open = false;
        this.stepNumber = -1;
        this.audioEnabled = false;
        this.typeSound = document.getElementById("typesound");

        this.messageElement = $("#guideMessage");
        this.saveElement = $("#saveGuide");
        this.spotlightInputElement = $("#spotlightInput");
        this.specialEffectInputElement = $("#sfxInput");
        this.mediaInputElement = $("#mediaInput");

        this.messageStatus = "clear";
        this.messageIntervalId = -1;

        this.initSteps();
        this.initKeybindListeners();
        this.initChangeListeners();
        this.initSaveListener();
        this.initAvatarListeners();
        this.initCloseButton();
        this.initMinimizeButton();
        this.initAddSlideButton();
        this.initDeleteSlideButton();
        this.initAudioUnlock();
        this.initOpenButton();
    }

    initSteps() {
        if (!guideData.steps) {
            this.steps = [this.getEmptyStep()];
            return;
        }
        this.steps = JSON.parse(guideData.steps).steps;
    }

    initOpenButton() {
        var _this = this;
        $(document).on("click", "#openGuideButton", function () {
            _this.initStartGuide();
        });
        if (guideData.autoOpen) {
            $(document).one("click keydown", function () {
                setTimeout(function () { _this.initStartGuide(); }, 300);
            });
        }
    }

    initStartGuide(stepNumber = -1) {
        if (this.open) {
            this._maximizeGuide();
            return;
        }
        this.clearSpotlight();
        this.stepNumber = stepNumber;
        this.finishMessage();
        this.play();
    }

    initAddSlideButton() {
        var _this = this;
        $("#addSlide").on("click", function () {
            _this.steps.splice(_this.stepNumber + 1, 0, _this.getEmptyStep());
            _this.markDirty();
            _this.play(true, _this.stepNumber);
        });
    }

    initDeleteSlideButton() {
        var _this = this;
        $("#deleteSlide").on("click", function () {
            _this.steps.splice(_this.stepNumber, 1);
            _this.markDirty();
            _this.play(true, Math.max(0, _this.stepNumber - 1) - 1);
        });
    }

    initSlideOptions() {
        if (this.stepNumber == -1) return;
        var step = this.steps[this.stepNumber];
        this.spotlightInputElement.val(step.spotlight);
        this.specialEffectInputElement.val(step.specialStart);
        this.mediaInputElement.val(step.media || "");
    }

    setSlideCount() {
        $("#currentStep").text(this.stepNumber + 1);
        $("#totalSteps").text(this.steps.length);
    }

    markDirty() {
        this.saveElement.attr("data-saved", "save");
        this.saveElement.removeClass("btn-secondary").addClass("btn-danger");
    }

    initChangeListeners() {
        var _this = this;
        this.messageElement.on("keyup paste", function () {
            _this.steps[_this.stepNumber].message = _this.messageElement.val();
            _this.markDirty();
        });
        this.spotlightInputElement.on("keydown paste input", function () {
            _this.steps[_this.stepNumber].spotlight = _this.spotlightInputElement.val();
            _this.markDirty();
        });
        this.specialEffectInputElement.on("keydown paste input", function () {
            _this.steps[_this.stepNumber].specialStart = _this.specialEffectInputElement.val();
            _this.markDirty();
        });
        this.mediaInputElement.on("keydown paste input", function () {
            _this.steps[_this.stepNumber].media = _this.mediaInputElement.val();
            _this.markDirty();
        });
    }

    initKeybindListeners() {
        var _this = this;
        $(document).on("keydown", function (e) {
            var code = e.keyCode || e.which;
            if (code == 34 && _this.stepNumber > -1) {
                _this.play();
            }
            if (code == 33 && _this.stepNumber > 0) {
                _this.stepNumber -= 2;
                _this.play(true);
            }
        });
        $("#continueGuideButton").on("click", function () {
            if (_this.stepNumber > -1) {
                _this.play();
            }
        });
    }

    initAudioUnlock() {
        var _this = this;
        var unlock = function () {
            _this.audioEnabled = true;
            $(document).off("pointerdown", unlock);
            $(document).off("keydown", unlock);
        };
        $(document).on("pointerdown", unlock);
        $(document).on("keydown", unlock);
    }

    safePlay(audio) {
        if (!this.audioEnabled || !audio || typeof audio.play !== "function") return;
        try {
            audio.play().catch(function () { });
        } catch (e) { }
    }

    initAvatarListeners() {
        var _this = this;
        this.leftAvatar.element.on("dblclick", function () {
            _this.leftAvatar.changeAvatar();
            _this.steps[_this.stepNumber].leftAvatar = _this.leftAvatar.getCurrentImage();
            _this.markDirty();
        });
        this.rightAvatar.element.on("dblclick", function () {
            _this.rightAvatar.changeAvatar();
            _this.steps[_this.stepNumber].rightAvatar = _this.rightAvatar.getCurrentImage();
            _this.markDirty();
        });
    }

    typeOutMessage(message) {
        var _this = this;
        var characterIndex = 0;
        var typeOne = function (init = false) {
            characterIndex += 1;
            _this.messageElement.val(message.substring(0, characterIndex));
            _this.messageElement.prop("disabled", true);
            _this.messageStatus = "unfinished";
            if (characterIndex % 2 == 0 && _this.typeSound) {
                _this.safePlay(_this.typeSound.cloneNode());
            }
            if (characterIndex >= message.length && !init) {
                _this.finishMessage(message);
            }
        };
        typeOne(true);
        this.messageIntervalId = setInterval(typeOne, 33);
    }

    finishMessage(message) {
        this.messageElement.val(message);
        this.messageStatus = "clear";
        clearInterval(this.messageIntervalId);
        if ($("#guidebox").hasClass("editmode")) this.messageElement.prop("disabled", false);
        var step = this.steps[this.stepNumber];
        if (step && step.media && step.media.length) {
            $("<img class='h-100 border rounded' style='object-fit:contain; max-width:100%;' id='gifVideoMedia' src='" + step.media + "'>").appendTo($("#mediaParent"));
        }
    }

    _continuePlay() {
        var step = this.steps[this.stepNumber];
        if (this.stepNumber == -1) {
            return true;
        }
        if (this.messageStatus == "unfinished") {
            this.finishMessage(step.message);
            return false;
        }
        if (this.steps.length == this.stepNumber + 1) {
            this._closeGuide();
            return false;
        }
        return true;
    }

    _minimizeGuide() {
        $("#guidebox").hide("clip", { "duration": 300 });
    }

    _maximizeGuide() {
        $("#guidebox").show("clip", { "duration": 300 });
    }

    _closeGuide() {
        var _this = this;
        _this.stepNumber = -1;
        _this.clearSpotlight();
        $("#guidebox").hide("clip", {
            "duration": 300,
            "complete": function () {
                _this.open = false;
            }
        });
    }

    _openGuide() {
        var _this = this;
        $("#guidebox").show("clip", {
            "duration": 300,
            "complete": function () {
                _this.open = true;
                _this.play(true);
            }
        });
    }

    play(force = false, jumpTo = null) {
        if (jumpTo !== null) {
            this.stepNumber = jumpTo;
        }
        if (!force && !this._continuePlay()) {
            return false;
        }
        if (this.stepNumber == -1 && !this.open) {
            this._openGuide();
            return false;
        }
        this.stepNumber += 1;
        if (this.stepNumber >= this.steps.length) {
            this.stepNumber = this.steps.length - 1;
        }
        var step = this.steps[this.stepNumber];

        this.leftAvatar.element.attr("src", step.leftAvatar || this.leftAvatar.talk);
        this.rightAvatar.element.attr("src", step.rightAvatar || this.rightAvatar.talk);

        $("#gifVideoMedia").remove();

        step.message.length === 0 && !$("#guidebox").hasClass("editmode") ? this.messageElement.hide() : this.messageElement.show();
        this.setMediaColumns();
        this.typeOutMessage(step.message);
        try {
            this.spotlight(step.spotlight);
        } catch (error) {
            console.error(error);
        }
        this.playConfetti(step.specialStart);

        this.leftAvatar.currentFrame = this.leftAvatar.getFrameIndexFromSrc(step.leftAvatar);
        this.rightAvatar.currentFrame = this.rightAvatar.getFrameIndexFromSrc(step.rightAvatar);

        this.initSlideOptions();
        this.setSlideCount();
        return true;
    }

    setMediaColumns() {
        var step = this.steps[this.stepNumber];
        if (step && step.media && step.media.length) {
            $("#guideMessageCol").removeClass("col").addClass("col-7");
            $("#mediaParentCol").removeClass("d-none").addClass("col-5");
        } else {
            $("#guideMessageCol").removeClass("col-7").addClass("col");
            $("#mediaParentCol").addClass("d-none").removeClass("col-5");
        }
    }

    playConfetti(name) {
        if (name == "confetti" || name == "firework") {
            launchConfetti();
        }
    }

    clearSpotlight() {
        $("#spotlight").remove();
    }

    spotlight(selector) {
        this.clearSpotlight();
        if (!selector) return;
        var rect = this.rectOf(selector);
        if (!rect) {
            console.error(selector + " doesn't exist.");
            return;
        }
        this.renderSpotlight(rect);
    }

    rectOf(selector) {
        var element = $(selector);
        if (!element.length || element.width() <= 0) return null;
        var offset = element.offset();
        return {
            left: offset.left,
            top: offset.top,
            width: element.outerWidth(),
            height: element.outerHeight()
        };
    }

    renderSpotlight(rect) {
        var pad = 16;
        var spotlight = $("<div>", { id: "spotlight" });
        spotlight.css({
            "border-radius": "10px",
            "transition": "box-shadow 0.5s ease-in-out",
            "box-shadow": "30px 30px 0px max(100vh, 100vw) rgba(0, 0, 0, 0.0)",
            "z-index": "9999",
            "position": "absolute",
            "pointer-events": "none",
            "width": rect.width + pad,
            "height": rect.height + pad,
            "left": rect.left - pad / 2,
            "top": rect.top - pad / 2
        });
        $("body").append(spotlight);
        setTimeout(function () {
            spotlight.css("box-shadow", "30px 30px 0px max(100vh, 100vw) rgba(0, 0, 0, 0.6)");
        }, 10);
    }

    getEmptyStep() {
        return {
            "leftAvatar": this.leftAvatar.talk,
            "rightAvatar": this.rightAvatar.talk,
            "message": "",
            "spotlight": "",
            "specialStart": "",
            "media": false
        };
    }

    getGuideManifest() {
        return JSON.stringify({ "steps": this.steps });
    }

    saveGuideToS3() {
        var _this = this;
        _this.saveElement.removeClass("btn-danger").addClass("btn-warning");
        $.post(guideData.ajaxUrl, {
            action: "saveGuide",
            guideNonce: guideData.guideNonce,
            guideManifest: _this.getGuideManifest(),
            puzzleId: guideData.guideId
        }, function (data) {
            if (data.success) {
                _this.saveElement.attr("data-saved", "saved");
                _this.saveElement.removeClass("btn-warning").addClass("btn-secondary");
            }
        });
    }

    initSaveListener() {
        $("#saveGuide").on("click", this.saveGuideToS3.bind(this));
    }

    initCloseButton() {
        var _this = this;
        $(document).on("click", "#closeGuide", function () {
            _this._closeGuide();
        });
    }

    initMinimizeButton() {
        var _this = this;
        $(document).on("click", "#minimizeGuide", function () {
            _this._minimizeGuide();
        });
    }
}

window.Avatar = Avatar;
window.Guide = Guide;

jQuery(function () {
    if (typeof guideData !== "undefined" && guideData.selfStarting) {
        window.guide = new Guide();
    }
});
